import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "status", "notice", "title"]
  static values = { success: String, error: String }

  async submit(event) {
    event.preventDefault()
    if (this.pending || !this.element.reportValidity()) return

    this.pending = true
    this.buttonTarget.disabled = true
    this.element.setAttribute("aria-busy", "true")
    this.noticeTarget.hidden = true
    this.titleTarget.hidden = true
    this.statusTarget.textContent = ""
    try {
      // Match Brevo's own form script: a direct browser POST with FormData and isAjax=1.
      const url = new URL(this.element.action)
      url.searchParams.set("isAjax", "1")
      const response = await fetch(url, {
        method: "POST",
        body: new FormData(this.element),
        credentials: "omit",
        signal: AbortSignal.timeout(15000)
      })
      const result = await response.json()
      if (!response.ok || result?.success !== true) throw new Error("Newsletter signup failed")

      this.titleTarget.hidden = false
      this.statusTarget.textContent = this.successValue
      this.element.reset()
    } catch {
      this.statusTarget.textContent = this.errorValue
    } finally {
      this.noticeTarget.hidden = false
      this.pending = false
      this.buttonTarget.disabled = false
      this.element.removeAttribute("aria-busy")
    }
  }
}
